<script lang="ts">
  import { getContext } from 'svelte';

  import { Title, Button } from '$shared/components';
  import ClearIcon from '$shared/images/emptyPage/clear.svg';
  import SearchIcon from '$shared/images/emptyPage/dataset-search.svg';
  import GroupIcon from '$shared/images/emptyPage/group.svg';
  import ProviderIcon from '$shared/images/emptyPage/provider.svg';
  import VerifyIcon from '$shared/images/emptyPage/verify.svg';
  import { ContextKeyLabel } from '$provider/constants/ContextKeyLabel';
  import { EmptyEntityType } from '$shared/constants/EmptyEntityType';
import { ButtonSize } from '$shared/constants/ButtonSize';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  enum OkLabel {
    Verify = 'Verify'
  }

  const IconMap: Record<EmptyEntityType, string> = {
    [EmptyEntityType.Verify]: VerifyIcon,
    [EmptyEntityType.Clear]: ClearIcon,
    [EmptyEntityType.Search]: SearchIcon,
    [EmptyEntityType.Provider]: ProviderIcon,
    [EmptyEntityType.Group]: GroupIcon
  };

  const context = getContext<ReadonlyContextType>(ContextKeyLabel.Readonly);

  const DefaultDesc = 'Run verification';
  const DefaultButtonLabel = OkLabel.Verify;

  interface Props {
    name?: string;
    desc?: string;
    verifyButtonLabel?: string;
    type?: EmptyEntityType;
    invert?: boolean;
    disabled?: boolean;
    hideAction?: boolean;
    onverify?: () => void;
  }

  let {
    name = '',
    desc = '',
    verifyButtonLabel = '',
    type = EmptyEntityType.Verify,
    invert = false,
    disabled = false,
    hideAction = false,
    onverify
  }: Props = $props();

  const onClickVerify = () => {
    onverify?.();
  };
</script>

<div data-cy="empty-entity" class="empty-entity" class:invert>
  <div class="icon-img">
    <img src={IconMap[type]} alt="Empty verification" />
  </div>
  <div data-cy="title" class="title">
    <Title>{name || 'Entity Name'}</Title>
  </div>
  <div data-cy="description" class="desc">{desc || DefaultDesc}</div>
  {#if !hideAction}
    <div class="verify-btn">
      <Button
        {name}
        size={ButtonSize.Large}
        style={ButtonStyle.Primary}
        onclick={onClickVerify}
        disabled={disabled || $context?.readonly}>{verifyButtonLabel || DefaultButtonLabel}</Button
      >
    </div>
  {/if}
</div>

<style>
  .empty-entity {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 50px;
    background-color: var(--grey-bg);
  }
  .empty-entity.invert {
    background-color: #fff;
  }
  .icon-img {
    width: 64px;
    margin-bottom: 24px;
  }
  .icon-img img {
    width: 100%;
  }
  .title {
    margin-bottom: 24px;
  }
  .desc {
    width: 500px;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
    text-align: center;
  }
  .verify-btn {
    margin-top: 40px;
  }
</style>
